import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ResourceSchemaCopy } from 'v5/core/entity-schema/resource/resourceSchemaCopy';
import { useRateCopy } from 'v5/patterns/forms/schema-form/fields/rate/useRateCopy';

/** The resource schema's words in the user's language. */
export function useResourceSchemaCopy(): ResourceSchemaCopy {
  const { t } = useTranslation('resources', { keyPrefix: 'ResourceSchema' });
  const rateCopy = useRateCopy();
  const { t: tCore } = useTranslation('core');
  return useMemo(
    () => ({
      coreLabel: {
        full_name: t('coreLabel.fullName'),
        pronouns: t('coreLabel.pronouns'),
        emails: t('coreLabel.emails'),
        phone_numbers: t('coreLabel.phoneNumbers'),
        socials: t('coreLabel.socials'),
        websites: t('coreLabel.websites'),
        tags: t('coreLabel.tags'),
        groups: t('coreLabel.groups'),
        locations: t('coreLabel.locations'),
        rates: t('coreLabel.rates'),
        represented_by_id: t('coreLabel.agent'),
        organisation_id: t('coreLabel.organization'),
        nick_name: t('coreLabel.nickname'),
        role: t('coreLabel.role')
      },
      enterPlaceholder: label =>
        t('enterPlaceholder', { label: label.toLowerCase() }),
      globalSection: t('globalSection'),
      rateItemTitle: t('rateItemTitle'),
      manageRateCards: tCore('rateEditor.manageRateCards'),
      locationItemTitle: t('locationItemTitle'),
      addRate: t('addRate'),
      blankRate: t('blankRate'),
      blankRateHint: t('blankRateHint'),
      fromRateCard: t('fromRateCard'),
      addItem: name => t('addItem', { name }),
      rateCard: rateCopy
    }),
    [t, tCore, rateCopy]
  );
}
